var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('toastification-variant'),_c('toastification-position'),_c('toastification-icon'),_c('toastification-timeout')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }